<template>
  <div v-if="criteresRecherche" class="tableWithPerPageSelection">
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              :options="actions"
              @handleAction="handleAction"
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="commandeAFactureSelectionne"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-4 pdr-0 pdl-0">
            <b-input :placeholder="$t('listeEcheances.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeEcheances.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permsCommandes.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="arrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <div class="columns is-multiline is-vcentered">
      <div class='column is-6'>
        <date-picker :dates="criteresRecherche.datesPrevisionnellesFacturation"
                     @recherche="recherche"/>
      </div>
      <suivi-mensuel
        class="column is-12"
        ref="suiviMensuel"
        :societe-id="societeActiveId"
        :agences-ids="criteresRecherche.agencesIds.length === 0
          ? agencesSelectionnees.map((agence) => agence.agenceId)
          : criteresRecherche.agencesIds"
        :periode="criteresRecherche.datesPrevisionnellesFacturation"
        :parutions-ids="[]">
      </suivi-mensuel>
    </div>
    <v-server-table
      url=""
      v-if="arrayRendering && mountedLoadingEnd"
      :columns="columns"
      class="tableWithChildRow"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable">
      <template #afterTable>
        <table-items-in-view
          :perPage="resultPerPage"
          @input='$refs[referenceTable].setLimit($event)' />
      </template>
      <template #appendBody>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="commandeAFacturer">
        </table-footer-totaux>
      </template>
      <template #selected = "{ row }">
        <qd-checkbox v-model="row.selected" class="has-text-centered"
                    :disabled="isFacturer(row)"
                    @input="selectionCommandeAFacturer()">
        </qd-checkbox>
      </template>
      <template #agence = "{ row }">
        {{ getAgenceLibelle(row.agenceId) }}
      </template>
      <template #code = "{ row }">
          <section class="is-flex is-justify-content-space-between">
            <router-link-blank
              :to="{ name: 'c.bodac.commandes', params: {id: row.id}}"
              :message="row.code"
              :class="{'text-access-no-permission': !checkPermissions(permsCommandes.lecture)}"
              class="lien is-inline">
            </router-link-blank>
            <send-facture-icon
                class="mgl-5px"
                :sendMail="checkFactureParEmail(row)"/>
            <tag-list
                class="mgl-2 is-justify-content-flex-end"
                v-if="getListeTags(row)"
                :listes="getListeTags(row)"/>
          </section>
      </template>
      <template #commercial = "{ row }">
        {{ getLibelleCommercial(row.commercialId) }}
      </template>
      <template #issuRenouvellement = "{ row }">
        <qd-checkbox :value="isIssueRenouvellement(row)"
                    class="has-text-centered pointer-events-none" type="is-default">
        </qd-checkbox>
      </template>
      <template #annonceurs = "{ row }">
        <router-link-blank v-for="(annonceur, index) in row.annonceurs"
                           :key="index"
                           :to="{ name: 'c.bodac.clients/contacts-client',
                           params: { id: annonceur.tiersId }}"
                           :message="annonceur.nomCommercial">
        </router-link-blank>
      </template>
      <template #payeurs = "{ row }">
        <router-link-blank v-for="(payeur, index) in row.payeurs"
                           :key="index"
                           :to="{ name: 'c.bodac.clients/contacts-client',
                           params: { id: payeur.tiersId }}"
                           :message="payeur.nomCommercial">
        </router-link-blank>
      </template>
      <template #datePremierAffichage = "{ row }">
        {{ formatDate(row.datePremierAffichage) }}
      </template>
      <template #datePrevisualisation = "{ row }">
        {{ formatDate(getDatePrevisiualisation(row)) }}
      </template>
      <template #montantHt = "{ row }">
        <div  class="has-text-right">{{ row.montantHt | formatDevise }}</div>
      </template>
      <template #montantHtPeriode = "{ row }">
        <div  class="has-text-right">{{ row.montantHtPeriode | formatDevise }}</div>
      </template>
      <template #categorieVente = "{ row }">
        {{ $t(getLibelleCategorieVente(row.categorieVente)) }}
      </template>
      <template #etat = "{ row }">
        {{ $t(getEtatCommande(row.etat)) }}
      </template>
      <template #commentaireInterne = "{ row }">
        <commentaireListInput
          :id="row.id"
          v-model="row.commentaireInterne"
          :maj="majCom">
        </commentaireListInput>
      </template>
      <template #facturer = "{ row }">
        <button class="button is-primary is-fullwidth"
                :disabled="isFacturer(row)"
                @click="saveInformationCommande([row])">
          {{ $t('listeCommandeAFacturer.table.facture') }}
        </button>
      </template>
      <template #editer = "{ row }">
        <b-tooltip
          size="is-large"
          position="is-left"
          type="is-info"
          :active="signatureElectroniqueActive"
          :label="$t('listeCommandeAFacturer.actions.telechargerCommandeSignee')">
          <div class="is-cursor-pointer"
            :class="{'disabled': row.cheminMin === ''}"
            @click="downloadCommandeSigne(row.cheminMin)">
            <b-icon
              :type="row.cheminMin === '' ? '' : 'is-primary'"
              icon="file-download">
            </b-icon>
          </div>
        </b-tooltip>
      </template>
    </v-server-table>
    <b-modal v-model="openPopUpFacturation"
             has-modal-card
             class="modal" >
      <pop-up-parametrage-facturation
        v-if="commandes.length > 0"
        @closeWithReload="closeAndRecherche"
        :commandes="commandes"
        :parutionId="$route.params.parutionId">
      </pop-up-parametrage-facturation>
    </b-modal>
    <b-modal v-model="openPopupMassIndexation" has-modal-card class="modal"
      v-if="moduleIndexationCommandeActive">
      <pop-up-indexation-en-masse
        :elementsSelectionnes="getCommandeAFacturerSelectionnes"
        @done="recherche"/>
    </b-modal>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-commande-a-facturer
          ref="filtreListeCommandeAFacturer"
          @toggleFiltre="setShowFiltre"
          @recherche="makeRechercheFilter()"
          :disabled-filter-parution="!!$route.params.parutionId"
          :factureParEmail="true"/>
      </div>
    </transition>
  </div>
</template>

<script>

import { COMMANDES } from '@/configuration/permissionsBodacConf';
import selecteurAction from '@/components/general/selecteurAction';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import datePicker from '@/components/general/datePicker';
import subscribeMutation from '@/services/store/subscribeMutation';
import tableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { cloneDeep } from 'lodash';
import {
  DEVIS_COMMANDE_ETAT,
  SENS_VENTE,
  COMMANDE_ETAT,
  ETAT_CLOTURER,
  ETAT_SANSSUITE,
} from '@/configuration/devisConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import filtreListeCommandeAFacturer from '@/components/devisCommandes/filtreListeCommandeAFacturer';
import formatIsoDate from '@/services/general/formatIsoDate';
import echeanceCommandeChildRow from '@/components/devisCommandes/rechercheCommande/echeanceCommandeChildRow';
import messageErreur from '@/services/general/messageErreur';
import { columnsSplice } from '@/services/general/columns';
import { ACTION_MASS_FACTURATION, ACTION_MASS_INDEXATION } from '@/configuration/general/actionsConf';
import popUpParametrageFacturation from '@/components/commande/aFacturer/popUpParametrageFacturation';
import suiviMensuel from '@/components/bodac/dcf/suiviMensuel/suiviMensuel';
import { get as getParution } from '@/api/presse/parution';
import { commenter } from '@/api/commandeAFacturer';
import { TYPE_DONNEE_EXCEL_COMMANDE_A_FACTURER } from '@/configuration/commande/commandeConf';
import { REFERENCE_TABLE_COMMANDE_A_FACTURER } from '@/configuration/general/referenceTableConf';
import parametrageTable from '@/components/general/parametrageTable';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import tagList from '@/components/general/tagList';
import formatDate from '@/services/general/formatDate';
import commentaireListInput from '@/components/general/input/commentaireListInput/commentaireListInput';
import popUpIndexationEnMasse from '@/components/devisCommandes/rechercheCommande/popUpIndexationEnMasse';
import checkPeriodeAndFormat from '@/services/dcf/checkPeriodeAndFormat';
import sendFactureIcon from '@/components/devisCommandes/sendFactureIcon';

const CommandeAFacturer = createNamespacedHelpers('commandeAFacturer');
const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'commandeAFacturer',
  data() {
    return {
      permsCommandes: COMMANDES,
      unsubscribeValue: null,
      arrayRendering: false,
      mountedLoadingEnd: false,
      commandeAFactureSelectionne: false,
      selectAllValue: false,
      showFiltre: false,
      allUser: [],
      sens: SENS_VENTE,
      openPopUpFacturation: false,
      commandes: [],
      parutionRoute: null,
      referenceTable: REFERENCE_TABLE_COMMANDE_A_FACTURER,
      routeParution: null,
      resultPerPage: RESULTS_PER_PAGE,
      formatDate,
      openPopupMassIndexation: false,
    };
  },
  components: {
    selecteurAction,
    datePicker,
    tableItemsInView,
    routerLinkBlank,
    filtreListeCommandeAFacturer,
    popUpParametrageFacturation,
    suiviMensuel,
    parametrageTable,
    tableFooterTotaux,
    exportExcelButton,
    commentaireListInput,
    popUpIndexationEnMasse,
    tagList,
    sendFactureIcon,
  },
  methods: {
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...CommandeAFacturer.mapActions({
      actionLoadCommandeAFacturer: 'loadCommandeAFacturer',
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getListeTags(row) {
      if (!row?.tags || row.tags.length === 0) return null;
      return row?.tags?.map(t => t.tag) ?? [];
    },
    isIssueRenouvellement(cmd) {
      return !!(cmd.devisCommandeInitialeId && cmd.devisCommandeInitialeId !== cmd.id);
    },
    getAgenceLibelle(agenceId) {
      const agenceActiveFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceActiveFind) return agenceActiveFind.libelleAgence;
      return '';
    },
    handleAction(action) {
      switch (action) {
        case ACTION_MASS_FACTURATION:
          this.saveInformationCommande(this.getCommandeAFacturerSelectionnes);
          break;
        case ACTION_MASS_INDEXATION:
          if (this.checkPermissions(this.permsCommandes.maj)) {
            this.openPopupMassIndexation = true;
          } else {
            this.showPopUp();
          }
          break;
        default:
          break;
      }
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeCommandeAFacturer.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
      this.$refs.suiviMensuel.reload();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    selectionCommandeAFacturer() {
      this.commandeAFactureSelectionne = this.commandeAFacturer.filter((el) => {
        return el.selected;
      }).length > 0;
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    updateAgenceAndRecherche() {
      this.criteresRecherche.agencesIds = this.agencesSelectionnees
        .map((agence) => agence.agenceId);
      this.recherche();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    closeAndRecherche() {
      this.recherche();
      this.openPopUpFacturation = false;
    },
    getEtatCommande(etat) {
      return DEVIS_COMMANDE_ETAT.find((etatInList) => {
        return etatInList.code === etat;
      }).libelle;
    },
    getLibelleCategorieVente(categorieVente) {
      const categorieFind = CATEGORIE_PRODUIT.find((categorie) => {
        return categorie.code === categorieVente;
      });
      return categorieFind ? categorieFind.libelle : '';
    },
    getLibelleCommercial(commercialId) {
      const commercial = this.allUser.find((user) => {
        return user.id === commercialId;
      });
      if (!commercial) return '';
      return commercial.decorator.nomPrenom;
    },
    selectAll() {
      this.selectAllValue = !this.selectAllValue;
      this.commandeAFacturer.forEach((el) => {
        if (!this.isFacturer(el)) el.selected = this.selectAllValue;
      });
      this.commandeAFactureSelectionne = this.selectAllValue;
    },
    saveInformationCommande(commandes) {
      this.commandes = commandes;
      this.openPopUpFacturation = true;
    },
    async reinitialiser() {
      await this.$refs.filtreListeCommandeAFacturer.initializeFiltre();
      await this.$refs.filtreListeCommandeAFacturer.viderCritere();
      this.$refs.filtreListeCommandeAFacturer.appliquerCritere();
      this.showFiltre = false;
    },
    isFacturer(commande) {
      return commande.echeancesLignes.some(ech => ech.facturationFaite || ech.factureId);
    },
    async filtreByRouteParutionId() {
      if (this.modulePresseActive && this.$route.params.parutionId) {
        if (!this.routeParution) {
          this.routeParution = (await getParution(this.$route.params.parutionId)).data.result;
          const dateParu = new Date(this.routeParution.dateParution);
          this.criteresRecherche.datesPrevisionnellesFacturation = {
            dateDebut: new Date(dateParu.getFullYear(), dateParu.getMonth(), 1),
            dateFin: new Date(dateParu.getFullYear(), dateParu.getMonth() + 1, 0),
          };
        }
        this.criteresRecherche.parutionsIds = [this.routeParution];
      }
    },
    checkFactureParEmail(commande) {
      return commande.payeurs
        .some(p => p.factureParMail);
    },
    getDatePrevisiualisation(commande) {
      const echeancesLignes = cloneDeep(commande.echeancesLignes);
      return echeancesLignes.sort((a, b) => (
        new Date(a.datePrevisionnelleFacturation).getTime()
        - new Date(b.datePrevisionnelleFacturation).getTime()
      ))[0].datePrevisionnelleFacturation;
    },
    majCom(id, commentaire) {
      return commenter({ id, commentaire });
    },
    downloadCommandeSigne(url) {
      const link = document.createElement('a');
      link.href = url;
      const segments = url.split('/');
      link.download = segments[segments.length - 1];
      link.click();
    },
  },
  computed: {
    ...User.mapGetters({
      user: 'user',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
      agencesSelectionnees: 'agenceActive',
      societeActive: 'societeActive',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...CommandeAFacturer.mapGetters({
      commandeAFacturer: 'commandeAFacturer',
      totalCount: 'totalCount',
      criteresRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    iconSelectTotal() {
      if (this.selectAllValue) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    moduleIndexationCommandeActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key);
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'societeId', 'datesPrevisionnellesFacturation', 'aFacturer', 'bonAFacturer', 'facturationFaite', 'etats', 'datesPrevisionnellesFacturationFacturee',
        'datesPrevisionnellesFacturationNonFacturee', 'factureParEmail', 'estSigne', 'estSigneElectroniquement', 'dateCommande', 'datePremierAffichage'];
      if (this.societeActive.agences.length === 1) banCritereKey.push('agencesIds');
      let nombreCritere = calculNombreCritere(this.criteresRecherche, banCritereKey);
      nombreCritere += this.criteresRecherche.facturationFaite !== null ? 1 : 0;
      nombreCritere += this.criteresRecherche.factureParEmail !== null ? 1 : 0;
      nombreCritere += this.criteresRecherche.estSigne !== null ? 1 : 0;
      nombreCritere += this.criteresRecherche.estSigneElectroniquement !== null ? 1 : 0;
      if (this.criteresRecherche.datePremierAffichage) {
        nombreCritere += this.criteresRecherche.datePremierAffichage.dateDebut ? 1 : 0;
        nombreCritere += this.criteresRecherche.datePremierAffichage.dateFin ? 1 : 0;
      }
      if (this.criteresRecherche.dateCommande) {
        nombreCritere += this.criteresRecherche.dateCommande.dateDebut ? 1 : 0;
        nombreCritere += this.criteresRecherche.dateCommande.dateFin ? 1 : 0;
      }
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    targetTotal() {
      return ['montantHt', 'montantHtPeriode'];
    },
    columns() {
      const columns = ['selected', 'code', 'categorieVente', 'datePremierAffichage', 'datePrevisualisation', 'codeDossier', 'etat', 'commercial', 'annonceurs', 'payeurs', 'issuRenouvellement', 'montantHtPeriode', 'montantHt', 'agence', 'commentaireInterne', 'facturer', 'editer'];
      if (this.societeActive.agences.length === 1) {
        columnsSplice(columns, 'agence');
      }
      if (!this.signatureElectroniqueActive) {
        columnsSplice(columns, 'editer');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeCommandeAFacturer.table.code'),
          commercial: this.$i18n.t('listeCommandeAFacturer.table.commercial'),
          annonceurs: this.$i18n.t('listeCommandeAFacturer.table.annonceurs'),
          payeurs: this.$i18n.t('listeCommandeAFacturer.table.payeurs'),
          datePremierAffichage: this.$i18n.t('listeCommandeAFacturer.table.dateCampagne'),
          datePrevisualisation: this.$i18n.t('listeCommandeAFacturer.table.datePrevisualisation'),
          etat: this.$i18n.t('listeCommandeAFacturer.table.etatCommande'),
          codeDossier: this.$i18n.t('listeCommandeAFacturer.table.codeDossier'),
          montantHt: this.$i18n.t('listeCommandeAFacturer.table.montantHtCommande'),
          montantHtPeriode: this.$i18n.t('listeCommandeAFacturer.table.montantHtPeriode'),
          categorieVente: this.$i18n.t('listeCommandeAFacturer.table.categorieVente'),
          agence: this.$i18n.t('listeCommandeAFacturer.table.agence'),
          issuRenouvellement: this.$i18n.t('listeCommandeAFacturer.table.issuRenouvellement'),
          commentaireInterne: this.$i18n.t('listeCommandeAFacturer.table.commentaireInterne'),
          editer: '',
          facturer: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        childRow: echeanceCommandeChildRow,
        texts: TEXTS,
        sortable: ['code', 'datePremierAffichage', 'etat', 'codeDossier', 'montantHt'],
        columnsClasses: {
          selected: 'colonneSelected',
        },
        requestFunction: (async (data) => {
          await this.filtreByRouteParutionId();
          if (this.criteresRecherche.agencesIds.length === 0) {
            this.criteresRecherche.agencesIds = this.agencesSelectionnees
              .map((agence) => agence.agenceId);
          }
          data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          data.query.sens = this.sens;
          data.query.bonAFacturer = true;
          data.query.factureId = null;
          checkPeriodeAndFormat(data.query, 'datePremierAffichage');
          checkPeriodeAndFormat(data.query, 'dateCommande');
          if (data.query.etats.length === 0) {
            data.query.etats = COMMANDE_ETAT
              .filter(e => ![ETAT_CLOTURER, ETAT_SANSSUITE].includes(e.code))
              .map((e) => e.code);
          }
          if (data.query.facturationFaite) {
            data.query.datesPrevisionnellesFacturationFacturee.dateDebut = formatIsoDate(
              data.query.datesPrevisionnellesFacturation.dateDebut,
            );
            data.query.datesPrevisionnellesFacturationFacturee.dateFin = formatIsoDate(
              data.query.datesPrevisionnellesFacturation.dateFin,
            );
            data.query.datesPrevisionnellesFacturation = {
              dateDebut: null,
              dateFin: null,
            };
          } else if (data.query.facturationFaite !== null && !data.query.facturationFaite) {
            data.query.datesPrevisionnellesFacturationNonFacturee.dateDebut = formatIsoDate(
              data.query.datesPrevisionnellesFacturation.dateDebut,
            );
            data.query.datesPrevisionnellesFacturationNonFacturee.dateFin = formatIsoDate(
              data.query.datesPrevisionnellesFacturation.dateFin,
            );
            data.query.datesPrevisionnellesFacturation = {
              dateDebut: null,
              dateFin: null,
            };
          } else {
            data.query.datesPrevisionnellesFacturation.dateDebut = formatIsoDate(
              data.query.datesPrevisionnellesFacturation.dateDebut,
            );
            data.query.datesPrevisionnellesFacturation.dateFin = formatIsoDate(
              data.query.datesPrevisionnellesFacturation.dateFin,
            );
          }
          data.query.tagIds = data.query.tagIds.map(t => t.id);
          if (data.query.groupeIds.length > 0) {
            data.query.groupeIds = data.query.groupeIds.map((groupe) => { return groupe.id; });
          }
          if (data.query.enseigneIds.length > 0) {
            data.query.enseigneIds = data.query.enseigneIds.map((enseigne) => {
              return enseigne.id;
            });
          }
          if (data.query.payeursId.length > 0) {
            data.query.payeursId = data.query.payeursId.map((payeur) => {
              return payeur.id;
            });
          }
          if (data.query.annonceursId.length > 0) {
            data.query.annonceursId = data.query.annonceursId.map((annonceur) => {
              return annonceur.id;
            });
          }
          if (data.query.categorieVente.length > 0) {
            data.query.categorieVente = data.query.categorieVente.map((categorie) => {
              return categorie.code;
            });
          }
          if (this.modulePresseActive && data.query.parutionsIds.length > 0) {
            data.query.parutionsIds = data.query.parutionsIds.map(el => el.id);
          }
          if (this.modulePresseActive && data.query.regleFacturationIds.length > 0) {
            data.query.regleFacturationIds = data.query.regleFacturationIds.map(el => el.id);
          }
          data.withCommandesSignees = this.signatureElectroniqueActive;
          this.$refs.suiviMensuel.reload();
          return this.actionLoadCommandeAFacturer(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.commandeAFacturer,
            count: this.totalCount,
          };
        }),
      };
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    exportExcelQuery() {
      return {
        typeDonnee: TYPE_DONNEE_EXCEL_COMMANDE_A_FACTURER,
        typeExport: null,
        filtres: this.lastPayload,
      };
    },
    signatureElectroniqueActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.signatureElectronique.key);
    },
    actions() {
      const actions = [{ action: ACTION_MASS_FACTURATION, translation: 'listeCommandeAFacturer.actions.facturer' }];
      if (this.moduleIndexationCommandeActive) {
        actions.push({
          action: ACTION_MASS_INDEXATION,
          translation: 'listeCommandes.actions.indexation',
        });
      }
      return actions;
    },
    getCommandeAFacturerSelectionnes() {
      return this.commandeAFacturer.filter((el) => {
        return el.selected;
      });
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
        PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key,
        PARAMETRES_INTERNE_KEYS.signatureElectronique.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key]);
      this.criteresRecherche.agencesIds = this.agencesSelectionnees
        .map((agence) => agence.agenceId);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      if (this.$route.params.sens) this.sens = this.$route.params.sens;
      await updateCritereWithParametreInterne(this.criteresRecherche);
      await this.loadParametreUtilisateur();
      this.allUser = this.parametre(PARAMETRES_KEYS.utilisateur);
      this.setInformationPage(this.$t('pageGescom.commande.listeCommandesAFacturer'));
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
